
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectId]/project-usage",
      function () {
        return require("private-next-pages/[projectId]/project-usage.tsx");
      }
    ]);
  